import React, { useEffect, useRef } from 'react'
import clsx from 'clsx'
import { CloseIcon } from '@astrid/components'

import './Modal.scss'

interface ModalProps {
  open: boolean
  closeModal?: () => void
  className?: string
}

const Modal: React.FC<ModalProps> = ({ open, closeModal, children, className }) => {
  const modalRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (open) {
      modalRef.current?.focus()
    }
  }, [open])

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!contentRef.current?.contains(event.target)) {
        closeModal && closeModal()
      }
    }

    const handleEscapeClick = (event: any) => {
      if (event.keyCode === 27) {
        event
        closeModal && closeModal()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscapeClick)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscapeClick)
    }
  }, [contentRef])

  if (!open) return null

  return (
    <div className="astrid-modal" role="dialog" tabIndex={-1} ref={modalRef}>
      <div className={clsx('astrid-modal__content', className)} ref={contentRef}>
        <div className="astrid-modal__scrollable">{children}</div>
        <button className="astrid-modal__close-icon" onClick={closeModal} aria-label="Close">
          <CloseIcon />
        </button>
      </div>
    </div>
  )
}

export default Modal
